export default "__VITE_ASSET__Dhwe_PUS__"